var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paypal-main"},[_c('div',{ref:"paypal",staticClass:"paypal-wrapper"}),(_vm.showStripe)?_c('div',{staticClass:"stripe-pay"},[_c('div',{staticClass:"button",on:{"click":_vm.handleStripePay}},[_vm._v(" Pay by Card ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }